import * as React from "react";

export const CalendarIcon = (props) => (
  <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 4c0-1.6 1.3-2.9 2.9-2.9h1V1a1 1 0 0 1 1.8 0h4.6a1 1 0 0 1 1.9 0h1c1.4.1 2.8 1.4 2.8 3v9.1c0 1.6-1.3 2.9-2.9 2.9H3a2.9 2.9 0 0 1-3-2.9V4Zm1.9 0c0-.5.4-1 1-1H13c.6 0 1 .5 1 1v1H3c0 1 .8 1.9 2 1.9h9V13c0 .6-.4 1-1 1H3a1 1 0 0 1-1-1V4Z"
      fill="#8888B5"
      fillOpacity={0.3}
    />
  </svg>
);
